import './App.css';
import { PartnerProvider, usePartner } from './PartnerContext';
import React, { useState, useRef, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import TabBar from './components/TabBar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import GamesView from './components/GamesView';
import SettingsView from './components/SettingsView';
import AuthPage from './components/AuthPage';
import DUMMY_DATA from './data/dummyData';

function getProjectsForOrg(orgId) {
  const org = DUMMY_DATA[orgId];
  if (!org) return [];
  return Object.entries(org.projects).map(([id, p]) => ({ id, name: p.name, logo: p.logo }));
}

function AppContent() {
  const { org, setOrg, project, setProject, user, setUser } = usePartner();
  const [openTabs, setOpenTabs] = useState(['analytics']);
  const [activeTab, setActiveTab] = useState('analytics');
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const email = user?.email || '';
  const orgOptions = Object.entries(DUMMY_DATA).map(([id, org]) => ({ id, name: org.name, logo: org.logo }));
  const projectOptions = getProjectsForOrg(org);

  // Close profile dropdown on login
  useEffect(() => {
    if (user) setProfileOpen(false);
  }, [user]);

  const openTab = (key) => {
    setOpenTabs(tabs => tabs.includes(key) ? tabs : [...tabs, key]);
    setActiveTab(key);
  };
  const closeTab = (key) => {
    if (openTabs.length === 1) return;
    const idx = openTabs.indexOf(key);
    const newTabs = openTabs.filter(t => t !== key);
    setOpenTabs(newTabs);
    if (activeTab === key) {
      setActiveTab(newTabs[Math.max(0, idx - 1)]);
    }
  };

  let content;
  if (activeTab === 'analytics') content = <Dashboard org={org} project={project} DUMMY_DATA={DUMMY_DATA} email={email} />;
  else if (activeTab === 'games') content = <GamesView />;
  else if (activeTab === 'settings') content = <SettingsView DUMMY_DATA={DUMMY_DATA} />;

  if (!user) {
    return <AuthPage onLogin={setUser} />;
  }
  return (
    <>
      <Header
        org={org}
        setOrg={setOrg}
        project={project}
        setProject={setProject}
        projectOptions={projectOptions}
        email={email}
        profileOpen={profileOpen}
        setProfileOpen={setProfileOpen}
        profileRef={profileRef}
        orgOptions={orgOptions}
        onLogout={() => setUser(null)}
      />
      <div className="layout">
        <Sidebar activeMenu={activeTab} openTab={openTab} />
        <div className="main-content">
          <TabBar openTabs={openTabs} activeTab={activeTab} setActiveTab={setActiveTab} closeTab={closeTab} />
          {content}
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <PartnerProvider>
      <AppContent />
    </PartnerProvider>
  );
}

export default App;
